import "../../../../components/atoms/buttons/button.scss";
import { memo } from "react";
import React, { useState, useEffect } from "react";
import "../../../../pages/login/login.scss";
import "@fortawesome/fontawesome-free/scss/fontawesome.scss";
import "@fortawesome/fontawesome-free/scss/solid.scss";
import ConstantesTabla from "../../../../utils/ConstantesTabla";
import DataTable from "react-data-table-component";
import ModalMensajes from "../../modals/modalMensajes/ModalMensajes";
import { useNavigate } from "react-router-dom";
import { anularPresentada, notificaPresentada } from "../../../services/DatoPersonalService";
import { Iconos } from "../../../../utils/Iconos";

const ActosPresentados = ({ setActosPresentados, actosPresentados, error,handleActualizarPresentada }) => {
  
  const [refresh, setRefresh] = useState(false);
  const handleRefresh = () => setRefresh(!refresh); // no va probar una actualizacion mejor
  // const [actosPresent, setActosPresent] = useState();

  const marginTop = {
    marginTop: "20px",
  };
  useEffect(() => { }, []);
  const [show, setShow] = useState({
    mensaje: false,
  });

  const handleClose = (e) => {
    setShow(false);
  };
  const handleShow = (e) => {
    setShow(e);
  };

  const descargarResolucion = (data) => {
    
    //Notificar justificante
    notificaPresentada(data[0],"z9").then(data => {
      handleRefresh();
      handleActualizarPresentada()
    })
  };

  useEffect(() => {
  },[refresh])

  const enCurso = (id) => {
    anularPresentada(id,"z9").then((data) => {
      if (data === "") {
        actosPresentados.filter((el) =>
          el.xsolactadm === id ? (el.estado = "ANULADA") : null
        );
        setActosPresentados(actosPresentados);
        handleShow({
          mensaje: true,
          content: "La solicitud se ha anulado correctamente.",
          tipo: "tituloModal",
          aviso: false,
          destinoAviso: null,
          destinoCerrar: null,
        });
      } else if (data === -1) {
        handleShow({
          mensaje: true,
          content: "La solicitud ya está anulada.",
          tipo: "tituloModal",
          aviso: false,
          destinoAviso: null,
          destinoCerrar: null,
        });
      }
    });
  };
  const navigate = useNavigate();

  const acJust = [{
    name: "Justificante",
    cell: (row) =>
      row.justificacionRealizada ? (
        <i
          title="Ver Justificante"
          className="fa-solid fa-file fs-1 mx-2 px-3 cursorPointer faHover"
          onClick={() => {
            // navigate(`/borradorActos/${row.id}`);
            navigate(`/actos/${row.xsolactadm}/justficacion`,{
              state:{nombre:row?.nombre,tipoActo:"z9"}
            })
            
          }}
          tabIndex={0}
        ></i>
      ) : null,
    sortable: true,
    center: true,
    grow: 3,
  },{
    name: "Acciones",
    center: true,
    cell: (row) =>
      row.estado === "EN CURSO" ? ( //EN CURSO
        <>
          <div
            className="d-flex align-align-center cursorPointer"
            onClick={() => {
              handleShow({
                mensaje: true,
                content: "¿Desea anular la solicitud?",
                tipo: "tituloModal",
                aviso: true,
                destinoAviso: null,
                destinoCerrar: null,
                funcion: enCurso,
                valorFuncion: row.xsolactadm,
              });
            }}
            tabIndex={0}
          >
            {/* <i className="rojo fa-solid fa-rectangle-xmark fs-3 faHover"></i> */}
            <div className="d-flex">
            {Iconos.iconoEliminar}
            <p className="ms-1">Anular</p>
            </div>
            
          </div>
        </>
      ) : row.estado.startsWith("RESOL") ? ( //RESUELTA - RESOL. FAV. Y RESOL DES.
        row.resolucionDisponible && !row.justificacionRealizada ? (
          <div
            className="mx-2 px-3 cursorPointer enlace azul text-center"
            onClick={() => {

              setShow({
                mensaje: true,
                content: "Se va a visualizar la Resolución y se va a guardar fecha y hora de la visualización.",
                contentBold: "",
                tipo: "tituloModal",
                aviso: true,
                funcion: descargarResolucion,
                valorFuncion: [row.xsolactadm, row.urlResolucion],
                destinoAviso: null,
                destinoCerrar: null,
              });
            }}
            tabIndex={0}
          >Ver Resolución</div>
        ) : (
          <p className="rojo"></p>
        )
      ) : row.estado === "ANULADA" ? null : null, //ANULADA
    sortable: true,
    grow: 5,
  }];

  const acciones = [
    
    {
      name: "Solicitud",
      cell: (row) => (
        <i
          className="fa-solid fa-file-pdf fs-3 mx-2 px-3 cursorPointer faHover"
          onClick={() => {
            navigate(`/descargarPresentadasActos/${row.xsolactadm}`,{state: {tipoActo:"z9"}});
          }}
          tabIndex={0}
        ></i>
      ),
      sortable: true,
      left: true,
      grow: 3,
    },
    {
      name: "Resolución",
      cell: (row) => row.resolucionDisponible && row.justificacionRealizada ? (<>
      <div className="mx-2 px-3 text-center">
        
        <i
          className="fa-solid fa-file fs-1 px-2 cursorPointer faHover"
          title="Ver Resolución"
          onClick={() => navigate(`/actos/${row.xsolactadm}/resolucion`,{
            state:{nombre:row?.nombre, tipoActo:"z9"}
          })}
          tabIndex={0}
        ></i>
        </div></>
      ) : null,
      sortable: true,
      left: true,
      grow: 3,
    },
  ];
  return (
    <>
      <div className="container" style={{ marginTop: "0px" }} role="main" data-landmark-index="4">
        <div>
          <div style={marginTop}>
            {!error ? (
              <DataTable
                className="table-responsive"
                columns={[
                  ...ConstantesTabla.columnasActosPresentados,
                  ...acciones,
                  ...acJust,
                ]}
                data={actosPresentados}
                pagination
                paginationComponentOptions={ConstantesTabla.paginacionOpt}
                noDataComponent={
                  <span>No se encontró ningún Acto Presentado</span>
                }
                customStyles={ConstantesTabla.customStyles}
                // fixedHeader
                // fixedHeaderScrollHeight="600px"
                style={marginTop}
              />
            ) : (
              <p className="rojo">No se ha podido conectar con el servidor</p>
            )}
          </div>
        </div>
      </div>
      {show.mensaje ? (
        <ModalMensajes
          show={show.mensaje}
          handleClose={handleClose}
          content={show.content}
          content2={show.content2}
          tipo={show.tipo}
          aviso={show.aviso}
          destinoAviso={show.destinoAviso}
          destinoCerrar={show.destinoCerrar}
          funcion={show.funcion}
          valorFuncion={show.valorFuncion}
          boton={show.boton}
          contentBold={show.contentBold}
        ></ModalMensajes>
      ) : null}
    </>
  );
};

export default memo(ActosPresentados);
